export default __webpack_public_path__ + "static/media/factory__21.22aade0c.jpg";